var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
var FileUpload = /** @class */ (function (_super) {
    __extends(FileUpload, _super);
    function FileUpload() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.files = [];
        _this.error = null;
        _this.dragOver = false;
        _this.loading = false;
        return _this;
    }
    Object.defineProperty(FileUpload.prototype, "localId", {
        get: function () {
            return this.id || "__ETM_FileUpload_" + getNextId() + "__";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FileUpload.prototype, "advanced", {
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FileUpload.prototype, "fileNames", {
        get: function () {
            return this.files
                .map(function (p) { return p.fileName; })
                .filter(function (p) { return p; });
        },
        enumerable: true,
        configurable: true
    });
    FileUpload.prototype.onFileNamesChanged = function (val) {
        if (this.multiple) {
            this.$emit("update:fileNames", val || []);
        }
        else {
            this.$emit("update:fileNames", val && val.length > 0 ? val[0] : null);
        }
    };
    FileUpload.prototype.onDrop = function (ev) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.advanced)
                            return [2 /*return*/];
                        if (this.loading)
                            return [2 /*return*/];
                        this.dragOver = false;
                        return [4 /*yield*/, this.processFiles(Array.from(ev.dataTransfer.files || []))];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    FileUpload.prototype.onChange = function (ev) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.processFiles(Array.from(ev.target.files))];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    FileUpload.prototype.processFiles = function (files) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var promises, _a, val, error_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.error = null;
                        this.loading = true;
                        files = this.multiple
                            ? files
                            : [files[0]];
                        promises = files
                            .map(function (p) { return __awaiter(_this, void 0, void 0, function () {
                            var bytes;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, readFile(p)];
                                    case 1:
                                        bytes = _a.sent();
                                        return [2 /*return*/, { fileName: p.name, bytes: bytes }];
                                }
                            });
                        }); });
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        _a = this;
                        return [4 /*yield*/, Promise.all(promises)];
                    case 2:
                        _a.files = _b.sent();
                        val = this.files.map(function (p) { return p.bytes; });
                        if (this.multiple) {
                            this.$emit("input", val);
                        }
                        else {
                            this.$emit("input", val[0]);
                        }
                        this.loading = false;
                        return [2 /*return*/, this.files];
                    case 3:
                        error_1 = _b.sent();
                        this.error = error_1;
                        this.files = [];
                        this.$emit("input", "");
                        this.loading = false;
                        return [2 /*return*/, []];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    __decorate([
        Prop({ type: String })
    ], FileUpload.prototype, "id", void 0);
    __decorate([
        Prop({ type: String })
    ], FileUpload.prototype, "name", void 0);
    __decorate([
        Prop({ type: Boolean, default: false })
    ], FileUpload.prototype, "multiple", void 0);
    __decorate([
        Prop({ type: Boolean, default: false })
    ], FileUpload.prototype, "fill", void 0);
    __decorate([
        Prop({ type: [String, Array] })
    ], FileUpload.prototype, "value", void 0);
    __decorate([
        Watch("fileNames")
    ], FileUpload.prototype, "onFileNamesChanged", null);
    FileUpload = __decorate([
        Component({
            name: "FileUpload"
        })
    ], FileUpload);
    return FileUpload;
}(Vue));
export default FileUpload;
;
var lastId = 1;
function getNextId() { return lastId++; }
function readFile(file) {
    return __awaiter(this, void 0, void 0, function () {
        var reader;
        return __generator(this, function (_a) {
            reader = new FileReader();
            return [2 /*return*/, new Promise(function (resolve, reject) {
                    reader.onload = function (e) {
                        var result = e.target.result;
                        if (result.indexOf("data:image/") === 0) {
                            resolve(result);
                        }
                        else {
                            reject("File was not an image!");
                        }
                    };
                    reader.onerror = function () {
                        reject("An error occurred!");
                    };
                    reader.readAsDataURL(file);
                })];
        });
    });
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/Components/FileUpload.vue
// module id = 875
// module chunks = 6